/**
 * Utilidades de pantalla para los catálogos del ERP (F1, B1).
 * Desde el 18-oct-2026 las pantallas usan el patrón de 2 pestañas (Consultar | Agregar / editar):
 * ver utils/pestanasErp.js. «Editar» (lápiz) abre la pestaña del formulario con el registro cargado.
 */

import '../../styles/erp_catalogos.css';

export const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Mensaje legible de un error de la API (incluye el detalle de validación de Joi). */
export function errMsg(err, porDefecto = 'No se pudo guardar') {
  if (!err) return porDefecto;
  if (Array.isArray(err.details) && err.details.length) return err.details.map((d) => d.message).join(' · ');
  return err.message || porDefecto;
}

export function badge(texto, tipo = 'info') {
  return `<span class="badge badge-${tipo}">${esc(texto)}</span>`;
}

export function estadoBadge(reg, { activo = 'Activo', inactivo = 'Inactivo' } = {}) {
  if (reg.deleted_at) return badge('Dado de baja', 'danger');
  return reg.activo ? badge(activo, 'success') : badge(inactivo, 'warning');
}

/** Lleva un elemento a la vista. (Antes del patrón de pestañas subía al formulario; se conserva para otras pantallas.) */
export function subirAlFormulario(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export const val = (id) => {
  const el = document.getElementById(id);
  if (!el) return undefined;
  if (el.type === 'checkbox') return el.checked;
  return el.value.trim();
};

export const numOrNull = (v) => (v === '' || v === undefined || v === null ? null : Number(v));

/** Texto de controles de la línea «serie*,motor,pedimento*» → chips. */
export function chipsControles(txt) {
  if (!txt) return '<span class="text-muted">—</span>';
  return String(txt).split(',').map((c) => {
    const oblig = c.endsWith('*');
    const nombre = c.replace('*', '');
    return `<span class="erp-chip ${oblig ? 'erp-chip-oblig' : ''}" title="${oblig ? 'Obligatorio' : 'Opcional'}">${esc(nombre)}${oblig ? ' *' : ''}</span>`;
  }).join(' ');
}

export const NOMBRE_CONTROL = {
  serie: 'Número de serie',
  motor: 'Número de motor',
  lote: 'Lote',
  caducidad: 'Caducidad',
  pedimento: 'Pedimento'
};
